module.exports = __webpack_public_path__ + "mozilla-logo.4ea30604.svg";